export default __webpack_public_path__ + "static/Sohne-Buch-383b619813ba6882f6f9025c0f320367.woff2";